<script setup lang="ts">
import { useUserStore } from '@/entities/user/model/userStore'
import { useRequestStore } from '@/features/requests/requests'

const userStore = useUserStore();
const requestStore = useRequestStore();

const settings = userStore.user.settingsJson;

interface Props {
  id: string;
  title: string;
  type: 'checkbox' | 'option';
  description?: string;
}

let timeoutId = null;

const handleChange = (ev) => {
  const id = ev.target.id;
  let value;
  if (props.type === 'checkbox') {
    value = ev.target.checked
  } else {
    value = 'implement-later';
  }

  if (timeoutId) {
    clearTimeout(timeoutId);
  }

  timeoutId = setTimeout(async () => {
    await requestStore.send('user/settings', {
      method: "POST",
      onlyWithAuth: true,
      payload: {
        id,
        value,
      },
    })
    await userStore.updateSettings();
  }, 500)
}

const props = defineProps<Props>();
</script>
<template>
  <div class="setting-item">
    <div class="setting-header">
      <label :for="props.id" class="setting-label">{{ props.title }}</label>
      <div class="checkbox-wrapper-57">
        <label class="container">
          <input :id="props.id" type="checkbox" @change="handleChange" :checked="settings[props.id]">
          <div class="checkmark"></div>
        </label>
      </div>
    </div>
    <label :for="props.id" v-if="props.description" class="setting-description">
      {{ props.description }}
    </label>
  </div>
</template>
<style lang="scss" scoped>
.setting-item {
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none;    /* Firefox */
  -ms-user-select: none;     /* IE 10+ */
  user-select: none;         /* Стандарт */
}

.setting-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.setting-label {
  cursor: pointer;
}

.setting-input {
  cursor: pointer;
}

.setting-description {
  font-size: 12px;
  line-height: 1.4;
  margin: 0;
  max-width: 85%;
  color: var(--text-secondary, rgba(0, 0, 0, 0.6));
}

.checkbox-wrapper-57 input[type="checkbox"] {
  visibility: hidden;
  display: none;
}

.checkbox-wrapper-57 *,
.checkbox-wrapper-57 ::after,
.checkbox-wrapper-57 ::before {
  box-sizing: border-box;
}

.checkbox-wrapper-57 .container {
  display: block;
  position: relative;
  cursor: pointer;
  font-size: 20px;
  user-select: none;
}

/* Create a custom checkbox */
.checkbox-wrapper-57 .checkmark {
  position: relative;
  top: 0;
  left: 0;
  height: 1.3em;
  width: 1.3em;
  background: black;
  border-radius: 50px;
  transition: all 0.7s;
  --spread: 9px;
}

/* When the checkbox is checked, add a blue background */
.checkbox-wrapper-57 .container input:checked ~ .checkmark {
  background: black;
  box-shadow:
    -6px -6px var(--spread) 0px rgba(139, 92, 246, 0.3),  /* фиолетовый */
    0 -6px var(--spread) 0px rgba(124, 58, 237, 0.3),      /* более темный фиолетовый */
    6px -6px var(--spread) 0px rgba(109, 40, 217, 0.3),   /* темно-фиолетовый */
    6px 0 var(--spread) 0px rgba(91, 33, 182, 0.3),       /* глубокий фиолетовый */
    6px 6px var(--spread) 0px rgba(76, 29, 149, 0.3),    /* очень темный фиолетовый */
    0 6px var(--spread) 0px rgba(124, 58, 237, 0.3),       /* повтор среднего оттенка */
    -6px 6px var(--spread) 0px rgba(167, 139, 250, 0.3);   /* светлый фиолетовый */
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkbox-wrapper-57 .checkmark::after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.checkbox-wrapper-57 .container input:checked ~ .checkmark::after {
  display: block;
}

/* Style the checkmark/indicator */
.checkbox-wrapper-57 .container .checkmark::after {
  left: 0.5em;
  top: 0.34em;
  width: 0.25em;
  height: 0.5em;
  border: solid #f0f0f0;
  border-width: 0 0.15em 0.15em 0;
  transform: rotate(45deg);
}
</style>
